import { render, staticRenderFns } from "./SearchPageHotelCardRightBlock.vue?vue&type=template&id=59b6e142&scoped=true&"
import script from "./SearchPageHotelCardRightBlock.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SearchPageHotelCardRightBlock.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./SearchPageHotelCardRightBlock.vue?vue&type=style&index=0&id=59b6e142&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b6e142",
  null
  
)

export default component.exports